export default "__VITE_ASSET__D_oCvqKv__"